export default "__VITE_ASSET__bpdz$DGF__";